module.exports = {
	"id": "BR",
	"name": "Brazil",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.01374,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.02748,
			"23": null,
			"24": null,
			"25": 0.00687,
			"26": 0.01374,
			"27": null,
			"28": 0.00687,
			"29": 0.02061,
			"30": 0.00687,
			"31": 0.01374,
			"32": 0.02748,
			"33": 0.02061,
			"34": 0.02748,
			"35": 0.02748,
			"36": 0.24045,
			"37": 0.03435,
			"38": 0.03435,
			"39": 0.04809,
			"40": 0.04122,
			"41": 0.03435,
			"42": 0.03435,
			"43": 0.37785,
			"44": 0.07557,
			"45": 0.05496,
			"46": 0.10992,
			"47": 0.16488,
			"48": 0.12366,
			"49": 1.61445,
			"50": 0.22671,
			"51": 1.25034,
			"52": 0.69387,
			"53": 37.01556,
			"54": 10.62102,
			"55": 0.17175,
			"56": 0.04809,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.01374,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.01374,
			"21": null,
			"22": null,
			"23": 0.00687,
			"24": 0.00687,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.00687,
			"29": null,
			"30": 0.01374,
			"31": 0.04809,
			"32": null,
			"33": 0.01374,
			"34": 0.01374,
			"35": 0.01374,
			"36": 0.01374,
			"37": 0.02061,
			"38": 0.07557,
			"39": 0.02061,
			"40": 0.02748,
			"41": 0.03435,
			"42": 0.02061,
			"43": 0.13053,
			"44": 0.04122,
			"45": 0.14427,
			"46": 0.09618,
			"47": 0.5496,
			"48": 0.37098,
			"49": 4.96014,
			"50": 0.04122,
			"51": 0.01374,
			"52": null,
			"3.5": null,
			"3.6": 0.00687
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.01374,
			"37": 0.02061,
			"38": 0.10305,
			"39": 0.01374,
			"40": 0.43968,
			"41": 0.07557,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.01374
		},
		"safari": {
			"0": null,
			"4": 0.00687,
			"5": 0.00687,
			"6": null,
			"7": 0.01374,
			"8": 0.06183,
			"9": 0.08244,
			"10": 0.61143,
			"3.1": null,
			"3.2": null,
			"5.1": 0.02061,
			"6.1": 0.02061,
			"7.1": null,
			"9.1": 0.38472
		},
		"ios_saf": {
			"8": 0,
			"10": 1.90704491341,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0513926537261,
			"8.1-8.4": 0.0949457501041,
			"9.0-9.2": 0.0452952202331,
			"9.3": 0.691042462531
		},
		"android": {
			"3": 0,
			"4": 0.0399263178295,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00499078972868,
			"4.1": 0.144019932171,
			"4.2-4.3": 0.360049830426,
			"4.4": 0.825619215116,
			"4.4.3-4.4.4": 0.832748914729
		},
		"ie": {
			"6": 0.00711696078431,
			"7": null,
			"8": 0.26332754902,
			"9": 0.206391862745,
			"10": 0.149456176471,
			"11": 1.55149745098,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0645606906259,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00179335251739
		},
		"edge": {
			"12": 0.06183,
			"13": 0.29541,
			"14": 0.68013
		},
		"ie_mob": {
			"10": 0.147553887324,
			"11": 0.600755112676
		},
		"bb": {
			"7": 0.003131,
			"10": null
		},
		"samsung": {
			"0": 1.781539
		},
		"and_uc": {
			"0": 0.491567
		},
		"op_mini": {
			"0": 0.869814956857
		},
		"and_chr": {
			"0": 24.321682
		},
		"and_ff": {
			"0": 0.012524
		}
	},
	"total": 98.344027
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BR.json
 ** module id = 483
 ** module chunks = 0
 **/